import {
  createClient,
  ClientContextProvider as CCP,
} from "react-fetching-library";
import { API_URL } from "config/constant";
import { jwtDecode } from "jwt-decode";
import { setItem } from "./CommonUtils";

const requestHostInterceptor =
  (host: any) => (client: any) => async (action: any) => {
    ///////////code to refresh_token if access_token expires////////////
    // @ts-ignore
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    if (
      action.endpoint !== "/v1/login/send-otp" &&
      action.endpoint !== `/v1/login/verify-otp` &&
      action.endpoint !== `/v1/news?platform=rekyc` &&
      action.endpoint !== '/v1/login/verify-birth-year'
    ) {
      var decoded: any = jwtDecode(
        // @ts-ignore
        JSON.parse(localStorage.getItem("access_token"))
      );

      if (Math.ceil(Date.now() / 1000) >= decoded.exp) {
        await fetch(`${host}/v1/login/refresh-token`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tokens?.refresh_token}`,
            Accept: "application.json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ucc_pan: "string",
            refresh_token: tokens.refresh_token,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            setItem("tokens", JSON.stringify(response?.data));
            setItem("access_token", JSON.stringify(response?.data?.access_token));
            if (response?.result?.flag === 0) {
              localStorage.clear()
              window.location.href = "/sessionexpired";
            }
          })
          .catch((err) => {
            localStorage.clear()
            window.location.href = "/sessionexpired";
          });
      }
      ///////////code to refresh_token if access_token expires end////////////

      action.headers = {
        // @ts-ignore
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("access_token"))}`,
      };

      return {
        ...action,
        endpoint: `${host}${action.endpoint}`,
      };
    } else {
      return {
        ...action,
        endpoint: `${host}${action.endpoint}`,
      };
    }

  };

const responseInterceptor =
  (client: any) => async (action: any, response: any) => {
    if (response.status === 401) {
      //handled above in request interceptors
      localStorage.clear()
      window.location.href = "/sessionexpired";
    }
    if (response.status === 500) {
    }
    return response;
  };

const clientOption = createClient({
  requestInterceptors: [requestHostInterceptor(API_URL)],
  responseInterceptors: [responseInterceptor],
});

export const client = clientOption;

export const ClientContextProvider = CCP;
